module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/book-pre-cover-txt.e30c142a.png";